import { waitFor } from "vue-wait";
import { strNormalize } from "@/utils/fn";
import { orderBy } from "lodash";
// import moment from 'moment'

// import PromotionTypes from '@/constants/promotion-types'
// import object from "@/utils/fn/object";
// import { WebshopCartItem } from "../../../services/models";

export default {
  data() {
    return {
      pausedBanner: false,
    };
  },
  methods: {
    goToProductDetails(product) {
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product,
      });
      this.$eventBus.$emit("close-product-added-to-cart-dialog");
      this.$router.push({
        name: "webshopChainProductDetails",
        params: {
          productId: product.idBase64 ? product.idBase64 : product.base64Id,
          productTitle: product.urlSafeTitle || "product",
        },
      });
    },

    goToBundle(bundle) {
      this.$store.dispatch("campaigns/set", { key: "bundle", value: bundle });
      this.$store.dispatch("webshop/set", {
        key: "selectedBundle",
        value: bundle,
      });
      this.$eventBus.$emit("close-product-added-to-cart-dialog");
      this.$router.push({
        name: "webshopCampaignBundle",
        params: {
          campaignId: bundle.campaignId || bundle.id,
          // productTitle: bundle.urlSafeTitle || 'product'
        },
      });
    },
    goToProductDetailsRec(item) {
      var link = item.urlSafe.split("/");
      this.$eventBus.$emit("close-product-added-to-cart-dialog");
      this.$router.push({
        name: "webshopChainProductDetails",
        params: {
          productTitle: link[0],
          productId: link[1],
        },
      });
    },
    goToCampaign(campaign) {
      this.$store.dispatch("campaigns/set", {
        key: "campaign",
        value: campaign,
      });
      this.$router.push({
        name: "webshopCampaignProducts",
        params: {
          campaignId: campaign.campaignId,
        },
      });
    },

    goToAllProducts() {
      this.$store.dispatch("campaigns/set", { key: "campaign", value: null });
      this.$router.push({
        name: "webshopProducts",
      });
    },

    getStockAmountForSite(site) {
      return (
        this.selectedProduct?.productDetails.inventory.find(
          (x) => x.siteId === site.siteId
        )?.stockAmount || 0
      );
    },

    getBundleStockAmountForSite(site) {
      return (
        this.selectedBundle?.subscriptions.find((x) => x.siteId === site.siteId)
          ?.availableAmount || 0
      );
    },

    getCartBundleStockAmountForSite(bundle, site) {
      return (
        bundle.subscriptionsList.find((x) => x.siteId === site)?.stockAmount ||
        0
      );
    },
    mapCategoriesRecursively(items, array) {
      items.forEach((c) => {
        if (this.productsSearchFilter)
          c.count = this.productsSearchFilter
            .map((x) => x.categoryId)
            .filter((x) => x === c.webshopCategoryId).length;
        array.push(c);
        if (c.children.length) this.mapCategoriesRecursively(c.children, array);
      });
    },

    onlyOneItemLeft(item) {
      var inventory = this.allProductsWithCart.find(
        (x) => x.id === item.id
      ).quantity;
      var totalQuantity = this.cartItems
        .filter((x) => x.id == item.id)
        .map((x) => x.quantity)
        .reduce((partialSum, a) => partialSum + a, 0);
      return inventory - totalQuantity == 1;
    },

    onlyOneBundleLeft(bundle) {
      return (
        this.getCartBundleStockAmountForSite(bundle, bundle.siteId) -
          bundle.quantity ===
          1 || bundle.maxPerCustomer - bundle.quantity === 1
      );
    },

    getCartCount(cartItems, cartBundles) {
      var products = cartItems.reduce((total, product) => {
        return total + product.quantity;
      }, 0);

      var bundles = cartBundles.reduce((total, product) => {
        return total + product.quantity;
      }, 0);

      return products + bundles;
    },

    removeItemFromCart(product) {
      waitFor(
        `loading clickAndCollect fetchDiscounts ${product.base64Id}`,
        async function () {
          await this.$store.dispatch("checkout/removeItemFromCart", {
            productId: product.base64Id,
            siteId: 0,
            deleteAllItems: false,
            treatmentId: "",
            chainId: this.currentChainId,
          });
          this.$eventBus.$emit("close-product-added-to-cart-dialog");
        }
      ).apply(this);
    },

    removeTreatmentFromCart(treatment) {
      waitFor(
        `loading clickAndCollect fetchDiscounts ${treatment.urlSafe}`,
        async function () {
          await this.$store.dispatch("checkout/removeTreatmentFromCart", {
            siteId: this.cartSite,
            deleteAllItems: false,
            treatmentId: treatment.urlSafe,
            chainId: this.currentChainId,
          });
          this.$eventBus.$emit("close-product-added-to-cart-dialog");
        }
      ).apply(this);
    },
    removeBundleFromCart(bundle) {
      waitFor(
        `loading clickAndCollect fetchDiscounts ${bundle.campaignId}`,
        async function () {
          await this.$store.dispatch("checkout/removeItemFromCart", {
            productId: bundle.campaignId.toString(),
            siteId: 0,
            deleteAllItems: false,
            treatmentId: "",
            chainId: this.currentChainId,
          });
          this.$eventBus.$emit("close-product-added-to-cart-dialog");
        }
      ).apply(this);
    },
    clearCart() {
      waitFor(`loading clickAndCollect fetchCart`, async function () {
        await this.$store.dispatch("checkout/removeItemFromCart", {
          siteId: 0,
          deleteAllItems: true,
          chainId: this.currentChainId,
        });
        this.$eventBus.$emit("close-product-added-to-cart-dialog");
      }).apply(this);
    },
    async addProductToSalonCart(salon) {
      waitFor(
        `loading clickAndCollect addProductToCart ${this.selectedProduct.id} ${
          (salon || this.selectedSalon).siteId
        }`,
        async function () {
          var selectedProductStock =
            this.selectedProduct.productDetails.inventory;
          var selectedProductQuantityInCart =
            this.$store.getters["checkout/cartProduct"]({
              id: this.selectedProduct.id,
              siteId: (salon || this.selectedSalon).siteId,
            })?.quantity || 0;
          // We have to check does a salon exist that can sell the combination of products in cart and the selected salon
          var salonsAvailableForCheckout =
            this.$store.getters["checkout/salonPool"]; // salons that can sell the cart content
          var selectedProductStockInSalonsAvailableForCheckout =
            selectedProductStock
              .filter(
                (p) =>
                  salonsAvailableForCheckout.includes(p.siteId) &&
                  p.stockAmount >= selectedProductQuantityInCart + 1
              )
              .map((s) => s.siteId);
          if (selectedProductStockInSalonsAvailableForCheckout.length) {
            let response = await this.$store.dispatch(
              "checkout/insertOrUpdateProduct",
              {
                quantity: selectedProductQuantityInCart + 1,
                productId: this.selectedProduct.idBase64,
                isCompleted: false,
                salePrice: this.selectedProduct.price,
                clientUuid: null,
                siteId: selectedProductStockInSalonsAvailableForCheckout[0],
              }
            );
            if (!response.data.responseCode === 200) {
              this.$eventBus.$emit("notify", {
                message: "Noe gikk galt, sjekk forbindelsen din og prøv igjen.",
                state: "error",
                title: "En feil oppstod",
                visible: true,
              });
            } else {
              this.$store.dispatch("webshop/set", {
                key: "addedToCartDialog",
                value: true,
              });
            }
          } else {
            this.$eventBus.$emit("notify", {
              message:
                "Dessverre kan ingen av avdelingene tilby alle de valgte produktene i en bestilling.",
              state: "delete",
              title: "Produkt kombinasjon ikke tilgjengelig",
              visible: true,
            });
          }
        }
      ).apply(this);
    },

    /**
     * TODO: Wait for add products endpoint
     */

    async addProductsToSalonCart(salon) {
      waitFor(
        `loading clickAndCollect addProductsToCart ${
          (salon || this.selectedSalon).siteId
        }`,
        async function () {
          var mergedPool = [];
          this.selectedProducts.forEach(async (selectedProduct) => {
            var selectedProductStock = selectedProduct.productDetails.inventory;
            var selectedProductQuantityInCart =
              this.$store.getters["checkout/cartProduct"]({
                id: selectedProduct.id,
                siteId: (salon || this.selectedSalon).siteId,
              })?.quantity || 0;
            // We have to check does a salon exist that can sell the combination of products in cart and the selected salon
            var salonsAvailableForCheckout =
              this.$store.getters["checkout/salonPool"]; // salons that can sell the cart content
            var selectedProductStockInSalonsAvailableForCheckout =
              selectedProductStock
                .filter(
                  (p) =>
                    salonsAvailableForCheckout.includes(p.siteId) &&
                    p.stockAmount >= selectedProductQuantityInCart + 1
                )
                .map((s) => s.siteId);
            selectedProductStockInSalonsAvailableForCheckout.forEach((a) => {
              mergedPool.push(a);
            });

          });
          // combined salon pool
          const counts = {};
          mergedPool.forEach(function (x) {
            counts[x] = (counts[x] || 0) + 1;
          });
          var finalPool = [...new Set(mergedPool)].filter(
            (x) => counts[x] == this.selectedProducts.length
          );
          if (finalPool.length) {
            this.selectedProducts.forEach(async (selectedProduct) => {
              var selectedProductQuantityInCart =
                this.$store.getters["checkout/cartProduct"]({
                  id: selectedProduct.id,
                  siteId: (salon || this.selectedSalon).siteId,
                })?.quantity || 0;
              let response = await this.$store.dispatch(
                "checkout/insertOrUpdateProduct",
                {
                  quantity: selectedProductQuantityInCart + 1,
                  productId: selectedProduct.idBase64,
                  isCompleted: false,
                  salePrice: selectedProduct.price,
                  clientUuid: null,
                  siteId: finalPool[0],
                }
              );
              if (!response.data.responseCode === 200) {
                this.$eventBus.$emit("notify", {
                  message:
                    "Noe gikk galt, sjekk forbindelsen din og prøv igjen.",
                  state: "error",
                  title: "En feil oppstod",
                  visible: true,
                });
              } else {
                this.$store.dispatch("webshop/set", {
                  key: "addedToCartDialog",
                  value: true,
                });
              }
            });
          } else {
            this.$eventBus.$emit("notify", {
              message:
                "Dessverre kan ingen av avdelingene tilby alle de valgte produktene i en bestilling.",
              state: "delete",
              title: "Produkt kombinasjon ikke tilgjengelig",
              visible: true,
            });
          }
        }
      ).apply(this);
    },

    async addBundleToSalonCart(salon) {
      waitFor(
        `loading clickAndCollect addBundleToCart ${
          this.selectedBundle.campaignId
        } ${(salon || this.selectedSalon).siteId}`,
        async function () {
          var selectedBundleStock = this.selectedBundle.subscriptionList;
          var selectedBundleQuantityInCart =
            this.$store.getters["checkout/cartBundle"]({
              id: this.selectedBundle.campaignId,
            })?.quantity || 0;
          // We have to check does a salon exist that can sell the combination of products in cart and the selected salon
          var salonsAvailableForCheckout =
            this.$store.getters["checkout/salonPool"]; // salons that can sell the cart content
          var selectedBundleStockInSalonsAvailableForCheckout =
            selectedBundleStock
              .filter(
                (p) =>
                  salonsAvailableForCheckout.includes(p.siteId) &&
                  p.availableAmount >= selectedBundleQuantityInCart + 1
              )
              .map((s) => s.siteId);

          if (selectedBundleStockInSalonsAvailableForCheckout.length) {
            let response = await this.$store.dispatch(
              "checkout/insertOrUpdateProduct",
              {
                quantity: selectedBundleQuantityInCart + 1,
                productId: this.selectedBundle.campaignId.toString(),
                isCompleted: false,
                salePrice: this.selectedBundle.campaignValue,
                clientUuid: null,
                siteId: selectedBundleStockInSalonsAvailableForCheckout[0],
              }
            );
            if (!response.data.responseCode === 200) {
              this.$eventBus.$emit("notify", {
                message: "Noe gikk galt, sjekk forbindelsen din og prøv igjen.",
                state: "error",
                title: "En feil oppstod",
                visible: true,
              });
            } else {
              this.$store.dispatch("webshop/set", {
                key: "addedToCartDialog",
                value: true,
              });
            }
          } else {
            this.$eventBus.$emit("notify", {
              message:
                "Dessverre kan ingen av avdelingene tilby alle de valgte produktene i en bestilling.",
              state: "delete",
              title: "Produkt kombinasjon ikke tilgjengelig",
              visible: true,
            });
          }
        }
      ).apply(this);
    },

    async updateBundleQuantity(bundle, val, action) {
      let quantity;
      if (!action) {
        quantity = parseInt(val);
      } else {
        quantity = bundle.quantity + (action === "increase" ? 1 : -1);
      }

      if (quantity < 1 || isNaN(quantity)) {
        quantity = 1;
      }
      var bundles = [
        {
          id: bundle.campaignId,
          quantity: quantity,
        },
      ];
      var salonPool = this.verifySalonPool([], bundles);
      var onlineQuantity = null;
      onlineQuantity = bundle.onlineStock || 0;
      // salonPool.forEach(s => {
      //    if (onlineQuantity == null) {
      //    }
      //    onlineQuantity += (bundle.subscriptionsList.find(a => a.siteId == s)?.availableAmount || 0)
      // })
      if (salonPool.length) {
        if (quantity > 0) {
          if (
            bundle.maxPerCustomer >= quantity &&
            (onlineQuantity >= 0 || onlineQuantity >= quantity)
          ) {
            waitFor(
              `loading clickAndCollect updateCartItemQuantity ${bundle.campaignId}`,
              async function () {
                let response = await this.$store.dispatch(
                  "checkout/insertOrUpdateProduct",
                  {
                    quantity: quantity,
                    productId: bundle.campaignId.toString(),
                    isCompleted: false,
                    salePrice: bundle.campaignValue,
                    clientUuid: null,
                    siteId: salonPool[0],
                  }
                );
                if (!response.data.responseCode === 200) {
                  this.$eventBus.$emit("notify", {
                    message:
                      "Noe gikk galt, sjekk forbindelsen din og prøv igjen.",
                    state: "error",
                    title: "En feil oppstod",
                    visible: true,
                  });
                }
              }
            ).apply(this);
          } else {
            this.$eventBus.$emit("notify", {
              message: `Du får nådd max antall av dette produktet. Salongen har kun ${bundle.maxPerCustomer} stk på lager`,
              state: "error",
              title: "Maks produktlager",
              visible: true,
            });
          }
        }
      } else {
        this.$eventBus.$emit("notify", {
          message:
            "Dessverre kan ingen av avdelingene tilby alle de valgte produktene i en bestilling.",
          state: "delete",
          title: "Produkt kombinasjon ikke tilgjengelig",
          visible: true,
        });
      }
    },
    verifySalonPool(productList, bundleList) {
      var activeSites = this.$store.getters["checkout/salonPool"];
      var products = this.cartProducts || [];
      var bundles = this.cartBundles || [];
      var productsStock = [];

      if (products.length) {
        for (var i in products) {
          var product = products[i];
          var stock = null;
          var productToChange = productList.find((p) => p.id == product.id);
          if (productToChange != null) {
            stock = product.stockAmount.filter(
              (s) =>
                activeSites.includes(s.siteId) &&
                s.productStockAmount >= productToChange.quantity
            );
          } else {
            stock = product.stockAmount.filter(
              (s) =>
                activeSites.includes(s.siteId) &&
                s.productStockAmount >= product.quantity
            );
          }
          stock.forEach((s) => productsStock.push(s.siteId));
        }
      }

      if (bundles.length) {
        for (var j in bundles) {
          var bundle = bundles[j];
          var bundlestock = null;
          var bundleToChange = bundleList.find((p) => p.id == bundle.id);
          if (bundleToChange != null) {
            bundlestock = bundle.subscriptionsList.filter(
              (s) =>
                activeSites.includes(s.siteId) &&
                s.availableAmount >= bundleToChange.quantity
            );
          } else {
            bundlestock = bundle.subscriptionsList.filter(
              (s) =>
                activeSites.includes(s.siteId) &&
                s.availableAmount >= bundle.quantity
            );
          }
          bundlestock.forEach((s) => productsStock.push(s.siteId));
        }
      }

      if (productsStock.length) {
        const counts = {};
        productsStock.forEach(function (x) {
          counts[x] = (counts[x] || 0) + 1;
        });

        return [...new Set(productsStock)].filter(
          (x) => counts[x] == products.length + bundles.length
        );
      }

      return [];
    },
    async updateItemQuantity(product, val, action) {
      let quantity;
      if (!action) quantity = parseInt(val);
      else {
        quantity = product.quantity + (action === "increase" ? 1 : -1);
      }
      if (quantity < 1 || isNaN(quantity)) quantity = 1;
      var products = [
        {
          id: product.id,
          quantity: quantity,
        },
      ];
      var salonPool = this.verifySalonPool(products, []);

      var onlineQuantity = 0;
      salonPool.forEach((s) => {
        onlineQuantity +=
          product.stockAmount.find((a) => a.siteId == s)?.productStockAmount ||
          0;
      });
      if (quantity > 0 && salonPool.length) {
        if (onlineQuantity >= quantity) {
          waitFor(
            `loading clickAndCollect updateCartItemQuantity ${product.id}`,
            async function () {
              let response = await this.$store.dispatch(
                "checkout/insertOrUpdateProduct",
                {
                  quantity: quantity,
                  productId: product.base64Id,
                  isCompleted: false,
                  salePrice: product.price,
                  clientUuid: null,
                  siteId: salonPool[0],
                }
              );
              if (!response.data.responseCode === 200) {
                this.$eventBus.$emit("notify", {
                  message:
                    "Noe gikk galt, sjekk forbindelsen din og prøv igjen.",
                  state: "error",
                  title: "En feil oppstod",
                  visible: true,
                });
              }
            }
          ).apply(this);
        } else {
          this.$eventBus.$emit("notify", {
            message: `Du får nådd max antall av dette produktet. Salongen har kun ${onlineQuantity} stk på lager`,
            state: "error",
            title: "Maks produktlager",
            visible: true,
          });
        }
      } else {
        this.$eventBus.$emit("notify", {
          message:
            "Dessverre kan ingen av avdelingene tilby alle de valgte produktene i en bestilling.",
          state: "delete",
          title: "Produkt kombinasjon ikke tilgjengelig",
          visible: true,
        });
      }
    },
    selectBrand(brand) {
      let urlBrands = this.urlBrands.slice();
      let urlSeries = this.urlSeries.slice();

      if (!this.urlBrands.includes(brand.id.Base64Guid)) {
        urlBrands.push(brand.id.Base64Guid);
      } else {
        let index = urlBrands.indexOf(brand.id.Base64Guid);
        urlBrands.splice(index, 1);
        urlSeries = urlSeries.filter(
          (x) => !brand.children.map((serie) => serie.id.Base64Guid).includes(x)
        );
      }

      this.$router
        .push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            brand: urlBrands,
            serie: urlSeries,
            page: 1,
          },
        })
        .catch(() => {});
    },

    selectSerie(serieId, brandId) {
      let urlSeries = this.urlSeries.slice();
      let urlBrands = this.urlBrands.slice();
      if (!this.urlSeries.includes(serieId)) {
        urlSeries.push(serieId);
        if (!this.urlBrands.includes(brandId)) urlBrands.push(brandId);
      } else {
        let index = urlSeries.indexOf(serieId);
        urlSeries.splice(index, 1);
      }

      this.$router
        .push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            serie: urlSeries,
            brand: urlBrands,
            page: 1,
          },
        })
        .catch(() => {});
    },
    selectSite(siteId) {
      let currentUrlSites = this.urlSites.slice();
      if (!this.urlSites.includes(siteId)) {
        currentUrlSites.push(siteId);
      } else {
        let index = currentUrlSites.indexOf(siteId);
        currentUrlSites.splice(index, 1);
      }

      this.$router
        .push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            site: currentUrlSites,
            page: 1,
          },
        })
        .catch(() => {});
    },

    async selectCategory(category, mainCategory) {
      category = JSON.parse(JSON.stringify(category));
      if (mainCategory) {
        mainCategory = JSON.parse(JSON.stringify(mainCategory));
        mainCategory.title = mainCategory.title.toLowerCase();
      }
      let urlCategories = this.urlCategories.slice();
      let urlMainCategories = this.urlMainCategories.slice();

      if (
        !(category.id ? this.urlCategories : this.urlMainCategories).includes(
          category.id
        )
      ) {
        urlCategories.push(category.id);
        if (mainCategory && !urlMainCategories.includes(mainCategory.title))
          urlMainCategories.push(mainCategory.title);
      } else {
        let index = urlCategories.indexOf(category.id);
        urlCategories.splice(index, 1);
      }
      this.$router
        .push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            category: urlCategories,
            mCategory: urlMainCategories,
            page: 1,
          },
        })
        .catch(() => {});
    },

    async selectMainCategory(category) {
      category = JSON.parse(JSON.stringify(category));
      category.title = category.title.toLowerCase();
      let urlMainCategories = this.urlMainCategories.slice();
      let urlCategories = this.urlCategories.slice();

      if (
        !(
          category.id ? this.urlMainCategories : this.urlMainCategories
        ).includes(category.title)
      ) {
        urlMainCategories.push(category.title);
      } else {
        let index = urlMainCategories.indexOf(category.title);
        urlMainCategories.splice(index, 1);
        urlCategories = urlCategories.filter(
          (x) =>
            !category.children.map((subCategory) => subCategory.id).includes(x)
        );
      }

      this.$router
        .push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            mCategory: urlMainCategories,
            category: urlCategories,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  computed: {
    hasBooking() {
      return !!this.salons.find((x) => x.hasBooking);
    },

    filterVisible() {
      return (
        [
          "webshopChainProductsMainCategories",
          "webshopChainProductsCategories",
          "webshopCampaignProducts",
        ].includes(this.$route.name) &&
        !this.$wait.is("loading webshop getCategories")
      );
    },

    purchasedProducts() {
      return this.$store.getters["userBehavior/get"]("purchasedProducts");
    },

    popularProducts() {
      return this.$store.getters["webshop/get"]("popularProducts");
    },

    mappedCategories() {
      let array = [];
      this.mapCategoriesRecursively(
        this.categories.map((x) => x.children).flat(),
        array
      );
      return array;
    },

    salonPickOptions() {
      return this.$store.getters["webshop/get"]("salonPickOptions");
    },

    bundleSalonPickOptions() {
      return this.$store.getters["webshop/get"]("bundleSalonPickOptions");
    },

    productsSalonPickOptions() {
      return this.$store.getters["webshop/get"]("productsSalonPickOptions");
    },

    clearCartPromptDialog() {
      return this.$store.getters["clickAndCollect/get"](
        "clearCartPromptDialog"
      );
    },

    salons() {
      return this.webshopSettings?.activatedSalons || [];
    },
    webshopPaused() {
      return this.webshopSettings
        ? !this.webshopSettings.active &&
            this.webshopSettings.activatedSalons.length
        : false;
    },
    webshopSettings() {
      return this.$store.getters["webshop/get"]("settings");
    },

    cart() {
      return this.$store.getters["checkout/get"]("cart");
    },

    cartItems() {
      return this.$store.getters["checkout/cartProducts"];
    },
    cartBundles() {
      return this.$store.getters["checkout/cartBundles"];
    },
    cartTreatments() {
      return this.$store.getters["checkout/cartTreatments"];
    },
    cartSite() {
      return this.$store.getters["checkout/cartSite"];
    },

    // cartProductsCount() {
    //    return this.$store.getters['checkout/cartsCount']
    // },
    async previouslyBoughtProducts() {
      await this.$store.dispatch("userBehavior/fetchPurchaseHistory", {
        chainId: this.currentChainId,
        onlineSluttKundeId: this.$user.onlineSluttKundeId,
        siteId: 0,
        activeSites: this.webshopSettings.activatedSalons.map(
          (salon) => salon.siteId
        ),
      });
    },

    products() {
      var products = this.$store.getters["webshop/getProducts"];

      return products;
    },
    allCampaigns() {
      return this.$store.getters["campaigns/get"]("campaigns");
    },
    campaigns() {
      return this.$store.getters["campaigns/get"]("campaigns").filter(
        (c) => c.promotionType.promotionTypeName != "Bundle" && c.imageUrl > 0
      );
    },
    campaignsByLevel() {
      return this.$store.getters["campaigns/get"]("campaignsByLevel");
    },
    selectedCampaign() {
      return this.$store.getters["campaigns/get"]("campaign");
    },
    selectedCampaignDuration() {
      if (this.selectedCampaign) {
        let time = this.selectedCampaign.campaignDateTo;
        let end = this.$moment(time);
        let start = this.$moment();
        let duration = this.$moment.duration(end.diff(start));

        if (Math.round(duration.asDays()) > 2) {
          return {
            time: this.$moment(time).format("DD. MMMM YYYY"),
            alert: false,
          };
        } else if (Math.round(duration.asDays()) <= 2) {
          return {
            time:
              Math.round(duration.asDays()) == 1
                ? "1 dag igjen"
                : "2 dager igjen",
            alert: true,
          };
        } else if (Math.round(duration.asDays()) < 1) {
          return {
            time: Math.round(duration.asHours()) + " timer igjen",
            alert: true,
          };
        }
      }
    },
    bundles() {
      let bundles = this.$store.getters["campaigns/get"]("bundles");
      return bundles;
    },
    selectedBundle() {
      return this.$store.getters["webshop/get"]("selectedBundle");
    },
    selectedBundleDuration() {
      if (this.selectedBundle) {
        let time = this.selectedBundle.campaignDateTo;
        let end = this.$moment(time);
        let start = this.$moment();
        let duration = this.$moment.duration(end.diff(start));

        if (Math.round(duration.asDays()) > 2) {
          return {
            time: this.$moment(time).format("DD. MMMM YYYY"),
            alert: false,
          };
        } else if (Math.round(duration.asDays()) <= 2) {
          return {
            time:
              Math.round(duration.asDays()) == 1
                ? "1 dag igjen"
                : "2 dager igjen",
            alert: true,
          };
        } else if (Math.round(duration.asDays()) < 1) {
          return {
            time: Math.round(duration.asHours()) + " timer igjen",
            alert: true,
          };
        }
      }
    },
    cartProducts() {
      return this.$store.getters["checkout/cartProducts"];
    },

    allProductsWithCart() {
      return this.cartProducts;
    },

    productsFiltered() {
      const category =
        typeof this.$route.query.category === "string"
          ? [parseInt(this.$route.query.category)]
          : (this.$route.query.category || []).map((x) => parseInt(x));
      const serie =
        typeof this.$route.query.serie === "string"
          ? [this.$route.query.serie]
          : (this.$route.query.serie || []).map((x) => x);
      const site =
        typeof this.$route.query.site === "string"
          ? [parseInt(this.$route.query.site)]
          : (this.$route.query.site || []).map((x) => parseInt(x));

      return this.products
        .filter(
          (x) =>
            !category || !category.length || category.includes(x.categoryId)
        ) // filter by category
        .filter(
          (x) =>
            !serie ||
            !serie.length ||
            serie.includes(strNormalize(x.serieName.toLowerCase()))
        ) // filter by series
        .filter(
          (x) =>
            !site || !site.length || site.some((r) => x.siteIds.includes(r))
        ); // filter by site

      // .filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i) // filter out duplicates by site
      // .filter(x => this.selectedSalon ? this.selectedSalon.siteId === x.siteId : true) // filer by site when siteId present else fetch all for chain
    },

    currentChainId() {
      return parseInt(this.$route.params.chainId || this.$route.query.chainId);
    },

    categoriesFilter() {
      return this.$store.getters["webshop/get"]("categoriesFilter");
    },

    brandsFilter() {
      return this.$store.getters["webshop/get"]("brandsFilter");
    },

    sitesFilter() {
      return this.$store.getters["webshop/get"]("siteFilters");
    },

    categories() {
      return this.$store.getters["webshop/get"]("categories");
    },

    productsWithDetails() {
      return this.$store.getters["webshop/get"]("productsDetails");
    },

    selectedSalon() {
      return this.$store.getters["webshop/get"]("selectedSalon");
    },

    selectedProduct() {
      return this.$store.getters["webshop/get"]("selectedProduct");
    },

    selectedProducts() {
      return this.$store.getters["webshop/get"]("selectedProducts");
    },

    brands() {
      return this.products
        .filter(
          (v, i, a) => a.findIndex((t) => t.brandName === v.brandName) === i
        )
        .map((b) => {
          return {
            title: b.brandName,
            children: this.products
              .filter((v, i, a) => {
                return (
                  b.brandName === v.brandName &&
                  a.findIndex((t) => t.serieName === v.serieName) === i
                );
              })
              .map((p) => {
                return { title: p.serieName };
              }),
          };
        });
    },
    allSeries() {
      let series = [];
      this.brandsFilter.forEach((brand) => {
        brand.children.forEach((serie) => {
          Object.assign(serie, { brandId: brand.id });
        });
        series = series.concat(brand.children);
      });
      return series;
    },
    getSeries() {
      return this.productsFiltered.map((x) => x.title);
    },

    getProductsByBrand: (title) => {
      return this.productsFiltered.filter((x) => x.title === title);
    },

    getProductsByIds: (guids) => {
      return this.productsFiltered.filter((x) => guids.includes(x.id));
    },

    urlSites() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.site
        ? Array.isArray(query.site)
          ? query.site.map((x) => parseInt(x))
          : [parseInt(query.site)]
        : [];
    },

    urlBrands() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.brand
        ? Array.isArray(query.brand)
          ? query.brand
          : [query.brand]
        : [];
    },

    urlSeries() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.serie
        ? Array.isArray(query.serie)
          ? query.serie
          : [query.serie]
        : [];
    },
    urlCategories() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.category
        ? Array.isArray(query.category)
          ? query.category.map((x) => parseInt(x))
          : [parseInt(query.category)]
        : [];
    },

    urlMainCategories() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.mCategory
        ? Array.isArray(query.mCategory)
          ? query.mCategory
          : [query.mCategory]
        : [];
    },

    allCategoriesByRoute() {
      let categories = (
        this.categoriesFilter.find(
          (c) => c.urlSafeName === this.$route.params.categoryFirst
        )?.children || []
      ).filter((x) => x.count > 0);
      if (this.$route.name === "webshopCampaignProducts") {
        this.categoriesFilter.forEach((c) => {
          if (c.children.length) {
            c.children.forEach((ch) => {
              Object.assign(ch, { parentCategoryId: c.id });
            });
          }
        });
        return orderBy(this.categoriesFilter, (x) => x.children.length, [
          "desc",
        ]);
      } else {
        categories.forEach((c) => {
          if (c.children.length) {
            c.children.forEach((ch) => {
              Object.assign(ch, { parentCategoryId: c.id });
            });
          }
        });
        return orderBy(categories, (x) => x.children.length, ["desc"]);
      }
    },

    filteredProductsCount() {
      return this.$store.getters["webshop/get"]("filteredProductsCount");
    },
    salonPool() {
      return this.$store.getters["checkout/salonPool"];
    },
    //recommendation engine
    cartItemIds() {
      const ids = [];
      this.cartItems.forEach((x) => ids.push(x.base64Id));
      return ids;
    },
    urlBase() {
      return process.env.VUE_APP_FIXIT_RECOMMENDATION_ENGINE_API_URL;
    },
  },
};
